<template>
	<nav :class="sidenavStyle + ` ` + sidenavBg">
		<div class="sidenav-menu">
			<div class="nav accordion" id="accordionSidenav">
				<div class="sidenav-menu-heading d-sm-none">
					{{ $t('sidenav.account') }}
				</div>
				<router-link to="/" class="nav-link d-sm-none" href="#!">
					<div class="nav-link-icon">
						accueil
						<fa icon="search"/>
					</div>
					{{ $t('sidenav.messages', 2) }}
					Accueil
				</router-link>

				<!-- Sidenav Heading (Home)-->
				<div v-if="this.$store.getters.loggedIn">
					<div class="sidenav-menu-heading">
						{{ $t('sidenav.home') }}
					</div>
					<!-- Sidenav Link (Home)-->
					<router-link v-if="modules.includes('admin')" class="nav-link" :to="{ name: 'home'}">
						<div class="nav-link-icon">
							<fa icon="home"/>
						</div>
						{{ $t('sidenav.home') }}
					</router-link>
					<div class="dropdown-divider" v-if="modules.includes('admin') && $store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_VENTE', 'ROLE_SUIVI', 'ROLE_STOCK'])"/>
					<router-link v-if="modules.includes('admin') && $store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_SUIVI', 'ROLE_VENTE', 'ROLE_STOCK'])" class="nav-link" :to="{ name: 'dashboard'}">
						<div class="nav-link-icon">
							<fa icon="dashboard"/>
						</div>
						{{ $t('sidenav.dashboard', 1) }}
					</router-link>
					<!-- Sidenav Link (Profile)-->
					<div class="dropdown-divider"/>
					<router-link v-if="this.$store.getters.loggedIn" class="nav-link" :to="{ name: 'profile'}">
						<div class="nav-link-icon">
							<fa icon="user-circle"/>
						</div>
						{{ $t('sidenav.profile') }}
					</router-link>
					<!-- ALL TYPES -->
					<div class="dropdown-divider m-0" v-if="$store.getters.isAuthorized(['ROLE_ADMIN'])"></div>
					<div v-if="$store.getters.isAuthorized(['ROLE_ADMIN'])" class="accordion" id="collapseAdmin">
						<div class="sidenav-menu-heading">
							{{$t('sidenav.admin', 1) }}
						</div>

						<router-link class="nav-link" :to="{ name: 'appconfig'}">
							<div class="nav-link-icon">
								<fa icon="dashboard"/>
							</div>
							{{ $t('sidenav.appconfig',1) }}
						</router-link>
						<div class="dropdown-divider"/>


						<div class="accordion-item" v-for="typeAdmin in listTypeAdmin" :key="typeAdmin.id" >
							<a v-if="$store.getters.isAuthorized(['ROLE_ADMIN'])"
								class="nav-link collapsed" data-bs-toggle="collapse" :data-bs-target="`#collapse${typeAdmin.id}`" aria-expanded="true" :aria-controls="`collapse${typeAdmin.id}`">
								<div class="nav-link-icon" :set="iconTT = `${typeAdmin.navIcon}` ">
									<fa v-if="typeAdmin && typeAdmin.navIcon" :icon="`${typeAdmin.navIcon}`" />
								</div>
								{{ $t(typeAdmin.navLabel, 2) }}
								<div class="sidenav-collapse-arrow">
									<fa icon="caret-down" />
								</div>
							</a>
							<!-- && modules.includes('individual') -->
							<div class="dropdown-divider"/>
							<div v-if="$store.getters.isAuthorized(['ROLE_ADMIN'])" :id="`collapse${typeAdmin.id}`"
								class="accordion-collapse collapse" :aria-labelledby="`collapse${typeAdmin.id}`" :data-bs-parent="`#collapse${typeAdmin.id}`"> 
								<nav class="sidenav-menu-nested nav">
									<router-link v-for="(instanceClass, key) in typeAdmin.instancesClass" :key="key" class="nav-link" :to="{ name: 'typesadmin' , params: {type:key} }">
										<div class="nav-link-icon">
											<fa v-if="instanceClass && instanceClass.iconClass" :icon="instanceClass.iconClass"/>
										</div>
										{{ $t(key + ".label") }}
									</router-link>
								</nav>
							</div>
						</div>
						<div class="dropdown-divider m-0"></div> 
					</div>
					<!-- FIN ALL TYPES -->
					<!-- ALL GESTION -->
					<div v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER', 'ROLE_VENTE', 'ROLE_STOCK', 'ROLE_SUIVI'])" class="accordion" id="collapseGestion">
						<div class="sidenav-menu-heading">
							{{$t('sidenav.gestion', 1) }}
						</div>
						<!-- TIERS -->
						<div class="accordion-item" v-if="$store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER'])" >
							<a class="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#collapseTiers" aria-expanded="true" aria-controls="collapseTiers">
								<div class="nav-link-icon">
									<fa icon="industry" />
								</div>
								{{ $t('sidenav.person.tiers', 1) }}
								<div class="sidenav-collapse-arrow">
									<fa icon="caret-down" />
								</div>
		
							</a>
							<div v-if="$store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER'])" id="collapseTiers" class="accordion-collapse collapse" aria-labelledby="collapseTiers"
							data-bs-parent="#collapseTiers"> 
								<nav class="sidenav-menu-nested nav">
									<li class="dropdown-divider"></li>
									<!-- <li class="dropdown-header">TIERS</li> -->
									
									<!-- LIST TIERS -->
									<div class="accordion-item">
										<a class="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#collapseTiersList" aria-expanded="true" aria-controls="collapseTiersList">
											<div class="nav-link-icon">
												<fa icon="industry" />
											</div>
											Liste
											<div class="sidenav-collapse-arrow">
												<fa icon="caret-down" />
											</div>
										</a>
										<div id="collapseTiersList" class="accordion-collapse collapse" aria-labelledby="collapseTiersList"
										data-bs-parent="#collapseTiersList"> 
											<nav class="sidenav-menu-nested nav">
												<router-link v-if="modules.includes('admin')" class="nav-link" :to="{ name: 'prspersonlist'}">
													<div class="nav-link-icon">
														<fa icon="list"/>
													</div>
													{{ $t('prsperson.list.all') }}
												</router-link>
												<router-link v-if="modules.includes('admin')" class="nav-link" :to="{ name: 'prspersonlisttype', params: {type:'1'}}">
													<div class="nav-link-icon">
														<fa icon="list"/>
													</div>
													{{ $t('prsperson.list.ep') }}
												</router-link>
												<router-link v-if="modules.includes('admin')" class="nav-link" :to="{ name: 'prspersonlisttype', params: {type:'2'}}">
													<div class="nav-link-icon">
														<fa icon="list"/>
													</div>
													{{ $t('prsperson.list.cl') }}
												</router-link>
												<router-link v-if="modules.includes('admin')" class="nav-link" :to="{ name: 'prspersonlisttype', params: {type:'3'}}">
													<div class="nav-link-icon">
														<fa icon="list"/>
													</div>
													{{ $t('prsperson.list.fr') }}
												</router-link>
												<router-link v-if="modules.includes('admin')" class="nav-link" :to="{ name: 'prspersonlisttype', params: {type:'4'}}">
													<div class="nav-link-icon">
														<fa icon="list"/>
													</div>
													{{ $t('prsperson.list.jl') }}
												</router-link>
												
											</nav>
										</div>
									</div>
									<li class="dropdown-divider"></li>
									<!-- AJOUT TIERS -->
									<div class="accordion-item">
										<a class="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#collapseTiersAdd" aria-expanded="true" aria-controls="collapseTiersAdd">
											<div class="nav-link-icon">
												<fa icon="industry" />
											</div>
											Ajouter
											<div class="sidenav-collapse-arrow">
												<fa icon="caret-down" />
											</div>
					
										</a>
										<div id="collapseTiersAdd" class="accordion-collapse collapse" aria-labelledby="collapseTiersAdd"
										data-bs-parent="#collapseTiersAdd"> 
											<nav class="sidenav-menu-nested nav">
												<router-link v-if="modules.includes('admin')" class="nav-link" :to="{ name: 'prsperson', params: {type:1}}">
													<div class="nav-link-icon">
														<fa icon="plus"/>
													</div>
													{{ $t('prsperson.button.ep') }}
												</router-link>
												<router-link v-if="modules.includes('admin')" class="nav-link" :to="{ name: 'prsperson', params: {type:2}}">
													<div class="nav-link-icon">
														<fa icon="plus"/>
													</div>
													{{ $t('prsperson.button.cl') }}
												</router-link>
												<router-link v-if="modules.includes('admin')" class="nav-link" :to="{ name: 'prsperson', params: {type:3}}">
													<div class="nav-link-icon">
														<fa icon="plus"/>
													</div>
													{{ $t('prsperson.button.fr') }}
												</router-link>
												<router-link v-if="modules.includes('admin')" class="nav-link" :to="{ name: 'prsperson', params: {type:4}}">
													<div class="nav-link-icon">
														<fa icon="plus"/>
													</div>
													{{ $t('prsperson.button.jl') }}
												</router-link>
												
											</nav>
										</div>
									</div>

								</nav>
							</div>
							
						</div>
						<div class="dropdown-divider" v-if="$store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_VENTE', 'ROLE_STOCK', 'ROLE_SUIVI'])"/>
						<!-- PROD -->
						<div class="accordion-item">
							<a v-if="$store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_VENTE', 'ROLE_STOCK', 'ROLE_SUIVI'])"
								class="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#collapseProd" aria-expanded="true" aria-controls="collapseProd">
								<div class="nav-link-icon">
									<fa icon="industry" />
								</div>
								{{ $t('sidenav.service.prod', 1) }}
								<div class="sidenav-collapse-arrow">
									<fa icon="caret-down" />
								</div>
		
							</a>
							<div id="collapseProd" class="accordion-collapse collapse" aria-labelledby="collapseProd"
							data-bs-parent="#collapseProd">
								<nav class="sidenav-menu-nested nav">
									<li class="dropdown-header" 
										v-if="modules.includes('admin') && $store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER'])">SUIVI</li>
									<router-link 
										v-if="modules.includes('admin') && $store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER'])" class="nav-link" :to="{ name: 'servteam'}">
										<div class="nav-link-icon">
											<fa icon="list"/>
										</div>
										{{ $t('servteam.list') }}
									</router-link>
									<router-link 
										v-if="modules.includes('admin') && $store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER'])" class="nav-link" :to="{ name: 'servteamop'}">
										<div class="nav-link-icon">
											<fa icon="add"/>
										</div>
										{{ $t('servteam.new') }}
									</router-link>
									<li class="dropdown-header">BONS</li>
									<router-link class="nav-link" :to="{ name: 'servorderlist'}">
										<div class="nav-link-icon">
											<fa icon="list"/>
										</div>
										{{ $t('servorder.list') }}
									</router-link>
									<router-link 
										v-if="modules.includes('admin') && $store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER'])" class="nav-link" :to="{ name: 'servorder'}">
										<div class="nav-link-icon">
											<fa icon="add"/>
										</div>
										{{ $t('servorder.new') }}
									</router-link>
								</nav>
							</div>
							
						</div>
						<div class="dropdown-divider"/>
						<!-- STOCK -->
						<div class="accordion-item" v-if="$store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_VENTE', 'ROLE_STOCK', 'ROLE_SUIVI'])">
							<a class="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#collapseStock" aria-expanded="true" aria-controls="collapseStock">
								<!-- :set="iconTT = user " -->
								<div class="nav-link-icon">
									<fa icon="bar-chart" />
								</div>
								{{ $t('sidenav.service.stock', 1) }}
								<div class="sidenav-collapse-arrow">
									<fa icon="caret-down" />
								</div>
							</a>
							<div id="collapseStock" class="accordion-collapse collapse" aria-labelledby="collapseStock"
							data-bs-parent="#collapseStock"> 
								<nav class="sidenav-menu-nested nav">
									<li class="dropdown-divider"></li>
									<li class="dropdown-header">OP</li>
									<router-link v-if="modules.includes('admin')" class="nav-link" :to="{ name: 'servop'}">
										<div class="nav-link-icon">
											<fa icon="list"/>
										</div>
										{{ $t('servop.list') }}
									</router-link>
									<router-link 
										v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER'])" class="nav-link" :to="{ name: 'servtypestockes'}">
										<div class="nav-link-icon">
											<fa icon="list"/>
										</div>
										{{ $t('servtypestockes.list') }}
									</router-link>
									<li class="dropdown-divider"></li>
									<li class="dropdown-header">STOCK</li>
									<router-link 
										v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER', 'ROLE_SUIVI'])" class="nav-link" :to="{ name: 'servtypeserv'}">
										<div class="nav-link-icon">
											<fa icon="list"/>
										</div>
										<!-- ETAT DES STOCKS -->
										{{ $t('servtypeserv.state') }}
									</router-link>

									<router-link v-if="modules.includes('admin')" class="nav-link" :to="{ name: 'servtypeservstore'}">
										<div class="nav-link-icon">
											<fa icon="list"/>
										</div>
										<!-- ETAT DES STOCKS PAR STORE -->
										{{ $t('servtypeservstore.state') }}
									</router-link>
								
								</nav>
							</div>
							
						</div>
						<div class="dropdown-divider"/>
						<!-- VENTE -->
						<div class="accordion-item" v-if="$store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_VENTE', 'ROLE_STOCK', 'ROLE_SUIVI'])" >
							<a v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER', 'ROLE_VENTE', 'ROLE_STOCK', 'ROLE_SUIVI'])"
								class="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#collapseVente" aria-expanded="true" aria-controls="collapseVente">
								<div class="nav-link-icon">
									<fa icon="cart-plus" />
								</div>
								{{ $t('sidenav.service.vente', 1) }}
								<div class="sidenav-collapse-arrow">
									<fa icon="caret-down" />
								</div>
		
							</a>
							<div id="collapseVente" class="accordion-collapse collapse" aria-labelledby="collapseVente"
							data-bs-parent="#collapseVente">
								<nav class="sidenav-menu-nested nav">
									<li class="dropdown-header">Commandes</li>
									<router-link class="nav-link" :to="{ name: 'prodorderlist'}">
										<div class="nav-link-icon">
											<fa icon="list"/>
										</div>
										{{ $t('prodorder.list') }}
									</router-link>
									<router-link v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER', 'ROLE_VENTE'])" class="nav-link" :to="{ name: 'prodorder'}">
										<div class="nav-link-icon">
											<fa icon="add"/>
										</div>
										{{ $t('prodorder.new') }}
									</router-link>
									
								</nav>
							</div>
							
						</div>

						<div class="dropdown-divider" v-if="$store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_VENTE', 'ROLE_SUIVI'])"/>
						<!-- MVT -->
						<div class="accordion-item" v-if="$store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_VENTE', 'ROLE_SUIVI'])">
							<a class="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#collapseMvt" aria-expanded="true" aria-controls="collapseMvt">
								<div class="nav-link-icon">
									<fa icon="signal" />
								</div>
									{{ $t('sidenav.mvt') }}
								<div class="sidenav-collapse-arrow">
									<fa icon="caret-down" />
								</div>
							</a>
							<div id="collapseMvt" class="accordion-collapse collapse" aria-labelledby="collapseMvt"
							data-bs-parent="#collapseMvt">
								<nav class="sidenav-menu-nested nav">
									<li class="dropdown-header">Mouvements</li>
									<router-link v-if="modules.includes('admin')" class="nav-link" :to="{ name: 'mvtmovementlist'}">
										<div class="nav-link-icon">
											<fa icon="list"/>
										</div>
										{{ $t('mvtmovement.list') }}
									</router-link>
								
									<li class="dropdown-divider"/>
									<!-- AJOUT MVT -->
									<div class="accordion-item" v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER', 'ROLE_VENTE'])">
										<a class="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#collapseAccDebt" aria-expanded="true" aria-controls="collapseAccDebt">
											<div class="nav-link-icon">
												<fa icon="minus-circle" style="color: red"/>
											</div>
											{{ $t('mvtmovement.button.debit') }}
											<div class="sidenav-collapse-arrow">
												<fa icon="caret-down"/>
											</div>
					
										</a>
										<div id="collapseAccDebt" class="accordion-collapse collapse" aria-labelledby="collapseAccDebt"
										data-bs-parent="#collapseAccDebt"> 
											<nav class="sidenav-menu-nested nav">
												<router-link v-if="modules.includes('admin')" v-for="mvtAccount in listAccount" :key="mvtAccount.id" class="nav-link" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:NaN, accId:mvtAccount.id, typeAdd:'one'} }">
													<div class="nav-link-icon">
														<fa icon="barcode"/>
													</div>
														{{mvtAccount.lib}}
												</router-link>

											</nav>
										</div>
									</div>
									<li class="dropdown-divider"/>
									<li class="dropdown-header">Multiple</li>
									<router-link v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER', 'ROLE_VENTE'])" class="nav-link" :to="{ name: 'mvtmovement', params: {typeMvt:1, typeDep:11, accId:NaN, typeAdd:'remb'} }">
										<div class="nav-link-icon">
											<fa icon="ellipsis-h"/>
										</div>
										{{ $t('mvtmovement.newremb') }}
									</router-link>
									<router-link v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER'])" class="nav-link" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:6, accId:1, typeAdd:'vcc'} }">
										<div class="nav-link-icon">
											<fa icon="exchange"/>
										</div>
										{{ $t('mvtmovement.newvcc') }}
									</router-link>
									
									<li class="dropdown-divider"/>
									<li class="dropdown-header">Compte</li>
									<router-link v-if="modules.includes('admin')" class="nav-link" :to="{ name: 'mvtaccount'}">
										<div class="nav-link-icon">
											<fa icon="list"/>
										</div>
										{{ $t('mvtaccount.list') }}
									</router-link>
									<!-- <router-link v-if="modules.includes('admin')" class="nav-link" :to="{ name: 'account'}">
										<div class="nav-link-icon">
											<fa icon="add"/>
										</div>
										{{ $t('account.new') }}
									</router-link> -->

									<li class="dropdown-header">Arrêté</li>
									<router-link v-if="modules.includes('admin')" class="nav-link" :to="{ name: 'mvtfinancialstatement'}">
										<div class="nav-link-icon">
											<fa icon="list"/>
										</div>
										{{ $t('mvtfinancialstatement.list') }}
									</router-link>

									<li class="dropdown-header">PAIE</li>
									<router-link v-if="modules.includes('admin')" class="nav-link" :to="{ name: 'mvtpayment'}">
										<div class="nav-link-icon">
											<fa icon="list"/>
										</div>
										{{ $t('mvtpayment.list') }}
									</router-link>
									<li class="dropdown-divider"/>
									<!-- AJOUT PAIE -->
									<div class="accordion-item" v-if="$store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_VENTE'])">
										<a class="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#collapsePayInd" aria-expanded="true" aria-controls="collapsePayInd">
											<div class="nav-link-icon">
												<fa icon="bolt" style="color: red"/>
											</div>
											{{ $t('mvtpayment.button.add') }}
											<div class="sidenav-collapse-arrow">
												<fa icon="caret-down"/>
											</div>
					
										</a>
										<div id="collapsePayInd" class="accordion-collapse collapse" aria-labelledby="collapsePayInd"
										data-bs-parent="#collapsePayInd"> 
											<nav class="sidenav-menu-nested nav">
												<router-link v-for="unpaidPrs in listUnpaidPrs" :key="unpaidPrs.id" class="nav-link" :to="{ name: 'mvtpaymentadd', params: {typePay:'ind', prsId:unpaidPrs.id, storeId:unpaidPrs.prsStore.id} }">
													<div class="nav-link-icon">
														<fa icon="user"/>
													</div>
													{{unpaidPrs.fullName}}
												</router-link>

											</nav>
										</div>
									</div>
									<li class="dropdown-divider"/>
									<router-link 
										v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER', 'ROLE_VENTE'])" class="nav-link" 
										:to="{ name: 'mvtpaymentadd', params: {typePay:'all', prsId:NaN, storeId:NaN} }">
										<div class="nav-link-icon">
											<fa icon="bolt" style="color: green"/>
										</div>
										{{ $t('mvtpayment.button.all') }}
									</router-link>

									<li v-if="$store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_SUIVI'])" class="dropdown-header">Inventaire</li>
									<router-link v-if="$store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_SUIVI'])" class="nav-link" :to="{ name: 'mvtinventory'}">
										<div class="nav-link-icon">
											<fa icon="list"/>
										</div>
										{{ $t('mvtinventory.list') }}
									</router-link>
									<li class="dropdown-divider"/>
									<router-link v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER'])" class="nav-link" :to="{ name: 'mvtinventoryadd'}">
										<div class="nav-link-icon">
											<fa icon="plus-circle"/>
										</div>
										{{ $t('mvtinventory.new') }}
									</router-link>

									<li class="dropdown-header">Ristourne</li>
									<router-link v-if="$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI', 'ROLE_VENTE'])" class="nav-link" :to="{ name: 'mvtrefund'}">
										<div class="nav-link-icon">
											<fa icon="list"/>
										</div>
										{{ $t('mvtrefund.list') }}
									</router-link>
									<li class="dropdown-divider"/>
									<router-link v-if="$store.getters.isAuthorized(['ROLE_MANAGER'])" class="nav-link" :to="{ name: 'mvtrefundadd'}">
										<div class="nav-link-icon">
											<fa icon="plus-circle"/>
										</div>
										{{ $t('mvtrefund.new') }}
									</router-link>
									<li class="dropdown-divider"/>
									<li class="dropdown-header">Ristourne Détails</li>
									<router-link v-if="$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI', 'ROLE_VENTE'])" class="nav-link" :to="{ name: 'mvtrefunditem'}">
										<div class="nav-link-icon">
											<fa icon="list"/>
										</div>
										{{ $t('mvtrefunditem.list') }}
									</router-link>
								</nav>
							</div>
							
						</div>

					</div>
					<!-- FIN ALL GESTION -->
				</div>
				<div v-else >
					<div style="text-align: center; background-color: white;">
						<h1></h1>
						<h6>Malienne de Productions Alimentaires</h6>
						<h2>MAPRAL - SARL (R.C.B. 7684)</h2>

						<img width="30%" src="@/assets/img/company/mapral_400x400.png" />

						<h1></h1>
						<h6>Niarela Rue Titi Niare  |   BP: 1628 BKO - MALI</h6>
						<h4 style="font-style: italic;">
							Tel.: 20 21 13 13  <br> 
							Fax: 20 21 02 75 <br> 
							Cel.: 76 23 58 78 <br>
						</h4>
						<h4>
							email: info@mapral.com <br>
							web: www.mapral.com <br>
						</h4>
						<br>
						<img width="90%" src="@/assets/img/company/Logo-PASTA BELLA -NEW-R_OFF.png" />
					</div>

					<!-- <h1 style="  text-transform: uppercase;">Malienne de Productions Alimentaires</h1>
					<h2>MAPRAL - SARL (R.C.B. 7684)</h2> -->
					<!-- <h3 style="color:#C50E0E !important; font-size: 31px !important; ">
						Coquillette N°4 | Coquillette N°6 | Coquillette N°7 | Escargot | Pastina | Riz | Torsade | Vermicelle | Cheveux d'ange
						
					</h3> -->
					<!-- ${produits} -->
					<!-- Pub style="margin: 100% 5% 50% 5%;"-->
					<!-- <img width="100%" src="@/assets/img/company/Kak-1.jpg" /> -->
					<!-- <img style="display: block; margin: auto; width: 50%;" src="@/assets/img/company/Logo-PASTA BELLA -NEW-R_OFF.png" /> -->
				</div>

			<!-- </nav>
		</div>
	</div> --> <!-- FIN ADMIN (GESTION) -->


			</div>
		</div>

		<!-- Sidenav Footer-->
		<div class="sidenav-footer">
			<div v-if="this.$store.getters.loggedIn" class="sidenav-footer-content">
				<div class="sidenav-footer-subtitle">
					{{ $t('sidenav.loggedinas') }}:
				</div>
				<div class="sidenav-footer-title">
					<!-- {{ username }} -->
					{{this.$store.getters.username}}
				</div>
			</div>
			<div v-else class="sidenav-footer-content">
				<button type="button" class="btn-xs btn-success" @click="this.$store.dispatch('auth')">
					<fa icon="sign-in"/> {{ $t('topnav.login', 1) }}
				</button>
			</div>
		</div>

	</nav>
</template>

<script>
import { NAVS_SEC } from '@/modules/typeadmin/details/sec-attrs';

import { NAVS_PRS } from '@/modules/typeadmin/details/prs-attrs';
import { NAVS_SERV } from '@/modules/typeadmin/details/serv-attrs';
import { NAVS_MVT } from '@/modules/typeadmin/details/mvt-attrs';
import { NAVS_REP } from '@/modules/typeadmin/details/rep-attrs';
// import { NAVS_NOT } from '@/modules/typeadmin/details/not-attrs';


export default {

	props: {
		// username: {
		// 	type: String,
		// 	required: true
		// },
		sidenavStyle: {
			type: String,
			default: 'sidenav shadow-right'
		},
		sidenavBg: {
			type: String,
			default: 'sidenav-light'
		}
	},
	data() {
		return {
			iconTest: 'user',
			modules: process.env.VUE_APP_MODULES?process.env.VUE_APP_MODULES.split(','): [],
			/*mapTypesAdmin : {
				security: NAVS_SEC, 
				person: NAVS_PRS,
				service: NAVS_SERV,
				movement: NAVS_MVT,
				report: NAVS_REP
			},*/
			listTypeAdmin: [],
			prsTypePersons: [],
			listAccount: [],
			listUnpaidPrs: []
		}
	},
	created () {
		// this.listTypeAdmin.push(... NAVS_SEC)
		// GET TYPE PERSON
		// if(this.$store.getters.loggedIn)
		// 	this.getPrsTypePersons()
	},
	mounted () {
		this.listTypeAdmin.push(... NAVS_SEC)
		this.listTypeAdmin.push(... NAVS_PRS)
		this.listTypeAdmin.push(... NAVS_SERV)
		this.listTypeAdmin.push(... NAVS_MVT)
		this.listTypeAdmin.push(... NAVS_REP)
		if(this.$store.getters.loggedIn) {
			try{
				this.getAccountMapral()
				this.getUnpaidPrs()
			}
			catch(e){
				console.log('axiosGet de sidenav = '+e)
			}
		}
	},
	methods: {
		async getAccountMapral() {
			if(this.$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_VENTE']) ){
				try{
					let strParams = "logCr=or&typeRender=list"
					if(this.$store.getters.isAuthorized(['ROLE_MANAGER']) )
						strParams = strParams+"&params1=prsPerson.id&valParams1="+1+"&logParams1=eqL"
					else if(this.$store.getters.isAuthorized(['ROLE_VENTE']) && this.$store.getters.prsInfo.prsStore != null )
						

						strParams = strParams+"&params1=prsStore.id&valParams1="+this.$store.getters.prsInfo.prsStore+"&logParams1=eqL"

					await this.$store.dispatch('axiosGet', { url: '/api/mvtaccount/getbycriteria?' + strParams
					})
					.then(response => {
						if(response.data)
							this.listAccount = response.data;
					})
					.catch(error => {
						console.log('error catch -listAccount == ', error.message)
					})
				}
				catch(e){
					console.log('getAccountMapral = '+e)
				}
			}			
			
		},
		async getUnpaidPrs() {
			if(this.$store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_VENTE']) ){
				try{
					await this.$store.dispatch('axiosGet', { url: '/api/mvtpayment/unpaidprs'
					})
					.then(response => {
						if(response.data)
							this.listUnpaidPrs = response.data;

						// console.log('this.listUnpaidPrs == ', this.listUnpaidPrs)
					})
					.catch(error => {
						console.log('error catch -listUnpaidPrs == ', error.message)
					})
				}
				catch(e){
					console.log('getUnpaidPrs = '+e)
				}

			}			
			
		}
		/*isAuthorized (auths) {
			if (this.$store.getters.roles)
				return auths.some(r => this.$store.getters.roles.includes(r))
			return false;
		},*/
		/*async getPrsTypePersons() {
			await this.$store.dispatch('axiosGet', {
				domain: 'prstypeperson'
			})
			.then(response => {
				this.prsTypePersons = response.data;
			}).catch(error => {
				console.log('error catch == ', error.message)
			})
		},*/

	}
}
</script>

<style>
	.sidenav .sidenav-menu .nav .nav-link {
		display: flex;
		align-items: center !important;
		line-height: normal !important;
		padding-top: .5rem !important;
		padding-bottom: .5rem !important;
		position: relative !important;
	}
	.sidenav .sidenav-menu .nav .sidenav-menu-heading {
		padding: 0.5rem 1rem 0.5rem !important;
		font-size: 0.7rem !important;
		font-weight: 0.5rem !important;
		text-transform: uppercase;
		letter-spacing: 0.05em;
	}
	.sidenav { font-size: .9rem !important;}
    
</style>
